import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { applyMiddleware, createStore, combineReducers } from 'redux';
import { composeWithDevToolsDevelopmentOnly } from '@redux-devtools/extension';
import thunk from 'redux-thunk';
import { createChordClient } from '../../services/chord';
import * as defaultReducer from '../reducers';
import defaultInitialState from './initial-state';
import { analytics as createAnalyticsMiddleware, persist as persistMiddleware, session as sessionMiddleware } from '../middleware';
import { initializeState } from '../actions';
var isBrowser = typeof window !== 'undefined';
var enhancers = composeWithDevToolsDevelopmentOnly({});
var createAppStore = function createAppStore(_ref) {
  var config = _ref.config,
    _ref$middleware = _ref.middleware,
    middleware = _ref$middleware === void 0 ? [] : _ref$middleware,
    _ref$preloadedState = _ref.preloadedState,
    preloadedState = _ref$preloadedState === void 0 ? {} : _ref$preloadedState,
    _ref$reducer = _ref.reducer,
    reducer = _ref$reducer === void 0 ? {} : _ref$reducer,
    auth = _ref.auth;
  var storeReducer = combineReducers(_objectSpread(_objectSpread({}, defaultReducer), reducer));
  var storePreloadedState = _objectSpread(_objectSpread({}, defaultInitialState), preloadedState);
  var chord = createChordClient(config);
  var analyticsMiddleware = createAnalyticsMiddleware({
    chord: chord
  });
  var storeEnhancer = enhancers(applyMiddleware.apply(void 0, [thunk.withExtraArgument({
    auth: auth,
    chord: chord,
    config: config
  }), persistMiddleware, analyticsMiddleware, sessionMiddleware].concat(_toConsumableArray(middleware))));
  var store = createStore(storeReducer, storePreloadedState, storeEnhancer);
  if (isBrowser) {
    store.dispatch(initializeState());
  }
  return store;
};
export default createAppStore;